import React from "react"
import styled from "@emotion/styled"
import { H2, P } from "../../Partials/Typography"
import VerticalSpacer from "../../Partials/VerticalSpacer"
import RightContainer from "../../Partials/RightContainer"
import { ParagraphsContainer } from "./ParagraphsContainer"
import ReactHtmlParser from "react-html-parser"
import { fontSize } from "../../../styles/fonts/fontStyle"
import { spacer } from "../../../styles/sizes"
import { deviceMinW } from "../../../styles/mediaQueries"

const Reflections = ({ title, paragraphs, fontColor }) => {
    return (
        <>
            <ReflectionsOuterContainer>
                <ReflectionsRightContainer>
                    <ReflectionsH2 fontColor={fontColor}>
                        {ReactHtmlParser(title)}
                    </ReflectionsH2>
                    <VerticalSpacer size="xl" />
                    <ParagraphsContainer>
                        {paragraphs.map(({ id, paragraph }) => (
                            <>
                                <ReflectionsP
                                    key={id}
                                    copy={paragraph}
                                    fontColor={fontColor}
                                >
                                    {ReactHtmlParser(paragraph)}
                                </ReflectionsP>
                            </>
                        ))}
                    </ParagraphsContainer>
                </ReflectionsRightContainer>
            </ReflectionsOuterContainer>
        </>
    )
}

export default Reflections

const ReflectionsOuterContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`
const ReflectionsRightContainer = styled(RightContainer)`
    flex-direction: column;
`
const ReflectionsH2 = styled(H2)`
    color: ${props => props.fontColor};
    font-size: ${fontSize.canon} !important;

    @media ${deviceMinW.laptop} {
        font-size: ${fontSize.foolscap} !important;
    }
`

const ReflectionsP = styled(P)`
    font-size: ${fontSize.bodyCopy};
    max-width: 45ch;
    padding-bottom: ${spacer.m};
    font-weight: 500;
    color: ${props => props.fontColor};

    &:last-of-type {
        padding-bottom: 0;
    }

    @media ${deviceMinW.tablet} {
        font-size: ${fontSize.doublePica};
    }
`
